module.exports = __webpack_public_path__ + "static/media/how-3.eff48750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/how-3.png
// module id = 353
// module chunks = 0